import { DateRange, Field, Filter, Button, SearchField } from "components/commons";
import React from "react";
import styles from "./redeem-history-filter.module.scss";
import locale from "localization";
import { SelectStation } from "components/field";

const RedeemHistoryFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  applyResetFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  exportReport,
  exporting,
  resetFilter,
  getUserAccess,
  modifyForm,
}) => {
  const { referenceStation } = filterState;

  return (
    <div className={styles.container}>
      <div className={styles.filter}>
        <Filter
          filterCount={filterCount}
          submit={applyFilter}
          close={resetFilter}
          clear={applyClearFilter}
        >
          <div
            style={{
              padding: "0px 20px",
            }}
          >
            <Field
              className={styles.date}
              label={locale.dateOfTransaction}
              labelPosition={"left"}
              childrenClassName={styles.fieldContent}
            >
              <DateRange
                value={{
                  startDate: filterState.startDate,
                  endDate: filterState.endDate,
                }}
                placeholder="Set Date"
                onChange={(_, { value }) => {
                  const { startDate, endDate } = value;
                  modifyFilter({
                    startDate: startDate,
                    endDate: endDate,
                  });
                }}
              />
            </Field>
            <Field
              label={`SEAOIL ${locale.station}`}
              labelPosition={"left"}
              className={styles.filterInput}
              childrenClassName={styles.fieldContent}
            >
              <SelectStation
                {...referenceStation}
                isMultiple
                disableAllOption
                isPlbOnboarded
                allLabel={locale.station}
                allSelectedText={locale.allStations}
                selectAllLabel={locale.allStations}
                onChange={(_, { value, isAll }) => {
                  modifyFilter({ referenceStation: { value, isAll } });
                }}
              />
            </Field>
          </div>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            placeholder={[locale.mobileNumber, locale.vipCardNumber, locale.vipTransactionId].join(
              ", "
            )}
            value={searchKey}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onClear={applyClearSearch}
            onEnter={applySearch}
            restrict={false}
          />
        </Field>
        <Field className={styles.downloadButton}>
          {(getUserAccess?.fullAccess || getUserAccess?.exportAccess) && (
            <Button
              startIcon={<span className="icon-download" />}
              exportButton
              onClick={exportReport}
              loading={exporting}
            >
              {locale.export}
            </Button>
          )}
        </Field>
      </div>
    </div>
  );
};

export default RedeemHistoryFilter;
